import React from 'react';
import { NotificationBanner, NotificationTypes } from '@chegg-ui/notification-banner';
import { Link } from '@chegg-ui/link';
import { colors, createTheme, ThemeProvider, themes } from '@chegg-ui/theme';
import { Divider, PaddingContainer } from './styled';
export var VPN_DETECTED_BANNER_ID = 'vpn_detected_banner';

/***
 * Renders a warning notification banner when the user uses a VPN
 */
var VpnNotificationBanner = function VpnNotificationBanner(_ref) {
  var bannerTitle = _ref.bannerTitle,
    link = _ref.link,
    linkText = _ref.linkText,
    isMobile = _ref.isMobile,
    allowPlanSelection = _ref.allowPlanSelection;
  var theme = createTheme({}, themes.horizon);
  return /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: theme
  }, !isMobile && !allowPlanSelection && /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement(PaddingContainer, {
    bottom: !isMobile && !allowPlanSelection ? 10 : 0,
    top: !isMobile && allowPlanSelection ? 20 : 0
  }, /*#__PURE__*/React.createElement(NotificationBanner, {
    id: VPN_DETECTED_BANNER_ID,
    "data-test": VPN_DETECTED_BANNER_ID,
    type: NotificationTypes.Warning,
    message: '',
    ctaLink: /*#__PURE__*/React.createElement(Link, {
      size: "sm",
      onClick: function onClick() {
        window.location.reload();
      },
      href: link,
      style: {
        color: colors.dark,
        textDecoration: 'underline',
        fontWeight: 'bold'
      }
    }, linkText),
    title: bannerTitle ? bannerTitle : ''
  })));
};
export default VpnNotificationBanner;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/commerce-utils/dist/esm/components/VpnNotificationBanner/VpnNotificationBanner.js
// module id = 3980
// module chunks = 11